
import { motion } from 'framer-motion';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const deepLink = 'https://onnyjob.onelink.me/z1EO/ussr8zbl?deep_link_value=eyJhZ2VuY3kiOiJBRzAyMjUyNjAwNTEifQ==';
  
  const menuItems = [
    { label: '채용정보', path: deepLink },
    { label: '인재찾기', path: deepLink },
    { label: '커뮤니티', path: deepLink },
    { label: '기업서비스', path: deepLink },
  ];

  return (
    <motion.nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="px-10 py-5 flex items-center justify-between">
        {/* Logo */}
        <a
          href={deepLink}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img 
            src="https://public.readdy.ai/ai/img_res/9b5ff483-3eed-4f76-9321-1639ea9d593d.png" 
            alt="온니잡 Logo" 
            className="h-10 w-auto"
          />
          <span className={`text-2xl font-bold ${scrolled ? 'text-dark-purple' : 'text-white'}`}>
            온니잡
          </span>
        </a>

        {/* Center Menu */}
        <div className="flex items-center gap-14">
          {menuItems.map((item) => (
            <a
              key={item.label}
              href={item.path}
              className={`text-base font-medium relative group transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-neon-purple' : 'text-white hover:text-neon-purple'
              }`}
            >
              {item.label}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-neon-purple group-hover:w-full transition-all duration-300"></span>
            </a>
          ))}
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-4">
          <a
            href={deepLink}
            className={`w-10 h-10 rounded-full border flex items-center justify-center transition-all cursor-pointer ${
              scrolled
                ? 'border-gray-300 text-gray-500 hover:border-neon-purple hover:text-neon-purple'
                : 'border-white/30 text-white/70 hover:border-neon-purple hover:text-neon-purple'
            }`}
          >
            <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href={deepLink}
            className={`px-7 py-3 rounded-full border transition-all whitespace-nowrap cursor-pointer ${
              scrolled 
                ? 'border-gray-300 text-gray-700 hover:border-neon-purple hover:text-neon-purple' 
                : 'border-white text-white hover:border-neon-purple hover:text-neon-purple'
            }`}
          >
            로그인
          </a>
          <a
            href={deepLink}
            className="px-7 py-3 rounded-full bg-gradient-neon text-white shadow-neon-purple hover:shadow-[0_0_30px_rgba(168,85,247,0.7)] transition-all whitespace-nowrap cursor-pointer"
          >
            회원가입
          </a>
        </div>
      </div>
    </motion.nav>
  );
}
